export enum ESectionStatus {
  COMPLETE,
  PARTIAL,
  UNTOUCHED,
  INCOMPLETE
}
